import { Location } from '@angular/common';
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { PaymentDataService } from '../services/payment-data.service';

export const paymentDataGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const paymentDataService = inject(PaymentDataService);
  const location = inject(Location);

  const paymentData = paymentDataService.getPaymentData();

  // Check if payment data exists and describes a charge (subscription product or one-time payment)
  if (paymentData && (paymentData.product || paymentData.payment)) {
    return true;
  }

  // If no payment data, go back to the previous page
  location.back();
  return false;
};
